var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpvote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24517 0.569001C5.95228 0.276108 5.47741 0.276108 5.18451 0.569001L0.411543 5.34197C0.11865 5.63486 0.11865 6.10974 0.411543 6.40263C0.704436 6.69552 1.17931 6.69552 1.4722 6.40263L5.71484 2.15999L9.95748 6.40263C10.2504 6.69552 10.7253 6.69552 11.0181 6.40263C11.311 6.10974 11.311 5.63486 11.0181 5.34197L6.24517 0.569001ZM6.46484 16.3672L6.46484 1.09933H4.96484L4.96484 16.3672H6.46484Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvote);
export default __webpack_public_path__ + "static/media/upvote.328a126852b85297d0182abef3b5bc6a.svg";
export { ForwardRef as ReactComponent };